import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import { CompleterData, CompleterItem } from 'ng2-completer';

export class SuggestAutocompleteDataService extends Subject<CompleterItem[]> implements CompleterData {

    private iconsCategories: Object
    private iconURLBase: String;
    private urlServerBase: String;

    constructor(private http: Http, private icons: Object, private iconURL: String, private URLBase: String) {
        super();
        this.iconsCategories = icons;
        this.iconURLBase = iconURL;
        this.urlServerBase = URLBase;
    }

    public search(term: string): void {
        term += "*";
        this.http.get(this.urlServerBase + term).map((res: Response) => {
            // Convert the result to CompleterItem[]
            let data = res.json();

            if (data && data.data) {
                let dades = data.data;

                let matches: CompleterItem[] = dades.map((suggestItem: any) => {

                    if (suggestItem.childs) {
                        let item = suggestItem.childs[0];
                        return {
                            title: suggestItem.label + " " + item.portal,
                            //description: "",
                            originalObject: suggestItem,
                            image: this.iconURLBase + this.iconsCategories[item.category]
                        }
                    }
                    else {
                        let category = suggestItem.category ? this.iconsCategories[suggestItem.category] : 'pois';
                        return {
                            title: suggestItem.label,
                            //description: "",
                            originalObject: suggestItem,
                            image: this.iconURLBase + this.iconsCategories[suggestItem.category]
                        }
                    }
                });
                console.log(matches);
                this.next(matches);
            }
        }).subscribe();
    }

    public cancel() { };
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/search/SuggestAutocompleteDataService.ts